import { get, post, put, destroy } from '@/api/request';

function fetchPtos(params = {}) {
  return get('/ptos', params);
}

function fetchSinglePto(id) {
  return get(`/ptos/${id}`);
}

function createPto(data) {
  return post('/ptos', data);
}

function updatePto({ id, data }) {
  return put(`/ptos/${id}`, data);
}

function deletePto(id) {
  return destroy(`/ptos/${id}`);
}

function changeStatus({ id, data }) {
  return put(`ptos/${id}`, data);
}

function fetchRejectedPtos(params = {}) {
  return get('/ptos', { ...params, status: 'rejected' });
}

function fetchPendingPtos(params = {}) {
  return get('/ptos', { ...params, status: 'pending' });
}

export default {
  fetchPtos,
  fetchSinglePto,
  createPto,
  updatePto,
  deletePto,
  changeStatus,
  fetchRejectedPtos,
  fetchPendingPtos,
};



// WEBPACK FOOTER //
// ./src/store/modules/pto/api.js